export default "__VITE_ASSET__B5Zt60X0__"